// extracted by mini-css-extract-plugin
export default {"iotPrivacy":"airPrivacy_iotPrivacy__gX9nh","pt18":"airPrivacy_pt18__MiaXw","pt12":"airPrivacy_pt12__RnZ+q","pt135":"airPrivacy_pt135__ne3wk"};